<div class="vi-breadcrumbs" data-at-breadcrumbs>
  <span
    [routerLink]="navigateTo"
    [queryParamsHandling]="paramsHandling"
    class="bread-crumb-formerPage lt-md:!hidden"
    >{{ formerPage }}</span
  >
  <span
    *ngIf="formerPage && currentPage"
    data-at-separator
    class="breadcrumb-separator lt-md:!hidden"
  >
    \
  </span>
  <span class="bread-crumb"> {{ currentPage }}</span>
</div>
